import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import { useTranslation } from "react-i18next";

const styles = ({ theme }) => {
  return {
    root: {
      margin: 0,
      padding: 0,
      listStyle: "none"
    },
    delete: {
      cursor: "pointer",
      display: "flex",
      backgroundColor: "transparent",
      alignItems: "center",
      border: "none",
      flexShrink: 0,
      color: theme.colors.quanternary1,
      fontFamily: theme.fonts.serif,
      fontSize: theme.textSizes.base,
      fontWeight: theme.fontWeights.semibold
    },
    icon: {
      marginRight: theme.margin["2"],
      lineHeight: 0
    },
    item: {
      display: "flex",
      justifyContent: "space-between",

      color: theme.colors.senary1,
      fontFamily: theme.fonts.serif,
      fontSize: theme.textSizes.base,
      fontWeight: theme.fontWeights.base,
      fontStyle: "italic",
      padding: [theme.padding["2"], 0],
      borderBottom: `1px solid ${theme.colors.primary3}`,
      "&:first-child": {
        borderTop: `1px solid ${theme.colors.primary3}`
      }
    }
  };
};

const FileList = ({ classes, files, handleOnRemoveFile }) => {
  const { t } = useTranslation();
  return (
    <ul className={classes.root}>
      {files.map(({ name, type, dataURL }) => (
        <li className={classes.item} key={name + type}>
          {name}
          <button className={classes.delete} onClick={handleOnRemoveFile(name)}>
            <svg
              className={classes.icon}
              width="16"
              height="16"
              viewBox="0 0 45 45"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M28.8511 22.5L43.722 7.62907C45.426 5.92512 45.426 2.98193 43.722 1.27797C42.0181 -0.42599 39.0749 -0.42599 37.3709 1.27797L22.5 16.1489L7.6291 1.27797C5.92514 -0.42599 2.98193 -0.42599 1.27797 1.27797C-0.42599 2.98193 -0.42599 5.92512 1.27797 7.62907L16.1489 22.5L1.27797 37.3709C-0.42599 39.0749 -0.42599 42.0181 1.27797 43.722C2.98193 45.426 5.92514 45.426 7.6291 43.722L22.5 28.8511L37.3709 43.722C39.0749 45.426 42.0181 45.426 43.722 43.722C45.426 42.0181 45.426 39.0749 43.722 37.3709L28.8511 22.5Z"
                fill="#c5131c"
              />
            </svg>

            {t(`list.item.remove.label`)}
          </button>
        </li>
      ))}
    </ul>
  );
};

FileList.propTypes = {
  files: PropTypes.array.isRequired
};

export default injectSheet(styles)(FileList);
